export default {
  category: {
    id: "solo-landing",
    label: "Solo Model Landing",
  },
};
